module.exports = __webpack_public_path__ + "static/icons/icon-unlock--white-72d7ea87056db430cb127bdc490f17ef.svg";